import { SEARCH, SEARCH_ERROR, SEARCH_SUCCESS } from '@fogia/core-web/state/models/Search/constants';
import store from '@fogia/core-web/state/store';
import getQueryParams from '@fogia/core-web/utils/getQueryParams';

export const search = (query, history, location) => (dispatch) => {
    dispatch({ type: SEARCH });
    try {
        const params = getQueryParams(location);
        params.search = encodeURI(query);

        if (query) {
            try {
                params.search = decodeURI(query);
            } catch (e) {
                console.error(e, 'Failed decode in dispatch');
            }
        } else {
            delete params.search;
        }

        history.replace(
            `?${Object.entries(params)
                .map((q) => q.join('='))
                .join('&')}`,
        );

        dispatch({
            type: SEARCH_SUCCESS,
            query,
        });
    } catch (e) {
        dispatch({ type: SEARCH_ERROR });
        throw e;
    }
};

export default (query, history, location) => store.dispatch(search(query, history, location));
